import { UrlConstants } from "../url.constants";
export class ApiModuleConstants {
    static URL = UrlConstants.API_V2 + "Module";
    static MISSING_LOOKUP_EMAIL_REQUEST_URL = "SendMissingLookupEmail";
    static GET_PORTAL_MODULES = "GetPortalModules";
}
